module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "w-100 h4 left-0 top z-5 flex justify-between items-center main pos-absolute"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [(_vm.logoSrc) ? _c('div', {
    staticClass: "white dib mt3"
  }, [_c('img', {
    staticClass: "h2",
    staticStyle: {
      "padding-top": ".2rem",
      "padding-bottom": "0",
      "margin-bottom": "-0.2rem"
    },
    attrs: {
      "alt": "",
      "src": _vm.logoSrc
    }
  })]) : _c('div', [(!_vm.isGenius) ? _c('akko-logo', {
    staticClass: "logo"
  }) : _vm._e(), _vm._v(" "), (_vm.isGenius) ? _c('GenuisCPRLogo') : _vm._e()], 1)]), _vm._v(" "), (_vm.showHelp) ? _c('div', {
    staticClass: "flex flex-row justify-between items-center right-button"
  }, [(!_vm.isMobile) ? _c('legend', {
    staticClass: ".inter need-help"
  }, [_vm._v("Need Help?")]) : _vm._e(), _vm._v(" "), _c('ak-button', {
    attrs: {
      "customClass": "bg-cream",
      "newSecondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openIntercomChat.apply(null, arguments)
      }
    }
  }, [_vm._v("\n      Contact Us\n    ")])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce899c7c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AkkoHeader.vue
// module id = 645
// module chunks = 0